"use strict";
// (C) 2021-2022 GoodData Corporation
Object.defineProperty(exports, "__esModule", { value: true });
exports.BearOrganizations = exports.BearOrganization = void 0;
var tslib_1 = require("tslib");
var sdk_backend_spi_1 = require("@gooddata/sdk-backend-spi");
var securitySettings_1 = require("./securitySettings");
var styling_1 = require("./styling");
var BearOrganization = /** @class */ (function () {
    function BearOrganization(authCall, organizationId, organizationName) {
        this.authCall = authCall;
        this.organizationId = organizationId;
        this.organizationName = organizationName;
    }
    BearOrganization.prototype.getDescriptor = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var accountInfo;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        // if we already have the data, no reason to download them again
                        if (this.organizationName) {
                            return [2 /*return*/, {
                                    id: this.organizationId,
                                    title: this.organizationName,
                                }];
                        }
                        return [4 /*yield*/, this.authCall(function (sdk) { return sdk.user.getAccountInfo(); })];
                    case 1:
                        accountInfo = _a.sent();
                        return [2 /*return*/, {
                                id: this.organizationId,
                                title: accountInfo.organizationName,
                            }];
                }
            });
        });
    };
    BearOrganization.prototype.securitySettings = function () {
        var organizationUri = "/gdc/domains/" + this.organizationId;
        return new securitySettings_1.SecuritySettingsService(this.authCall, organizationUri);
    };
    BearOrganization.prototype.styling = function () {
        return new styling_1.OrganizationStylingService();
    };
    BearOrganization.prototype.settings = function () {
        throw new sdk_backend_spi_1.NotSupported("Backend does not support organization settings service");
    };
    return BearOrganization;
}());
exports.BearOrganization = BearOrganization;
var BearOrganizations = /** @class */ (function () {
    function BearOrganizations(authCall) {
        this.authCall = authCall;
    }
    BearOrganizations.prototype.getCurrentOrganization = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a, id, name;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, this.authCall(function (sdk) { return sdk.organization.getCurrentOrganization(); })];
                    case 1:
                        _a = (_b.sent()).organization, id = _a.id, name = _a.name;
                        return [2 /*return*/, new BearOrganization(this.authCall, id, name)];
                }
            });
        });
    };
    return BearOrganizations;
}());
exports.BearOrganizations = BearOrganizations;
//# sourceMappingURL=index.js.map